<template>
    <div style="width:100%;heigh:100%;" id="master-data-config">
        <el-card class="table-card">
            <el-tabs tab-position="left" v-model="activeName" @tab-click="handleClick">
            
                <el-tab-pane label="产品类型" name="1" v-if="permission.btn_masterData_listProductionType">
                    <div>
                        <h3 style="margin-bottom:20px">产品类型</h3>
                        <div class="table_common_operbar">
                            <el-row>
                                <el-button icon="el-icon-plus" type="primary" size="small" @click="addWindowShow()" v-if="permission.btn_masterData_addProductionType">新增</el-button>
                                <el-upload class="import_upload" accept=".xls, .xlsx" :action="uploadUrl()"  :before-upload='beforeLoad' :on-success="uploadComplete" v-if="permission.btn_masterData_importProductionType">
                                    <el-button icon="el-icon-upload el-icon--left" type='primary' size="small">导入</el-button>
                                </el-upload>
                                <div class="import_upload" v-if="permission.btn_masterData_downloadProductionTypeTemplate">
                                    <a class="import_upload" href="/api/masterData/downloadProductionTypeTemplate">
                                        <el-button  size='small'>模板下载<i class="el-icon-download el-icon--right"></i></el-button>
                                    </a>
                                </div>
                            </el-row>
                        </div>

                        <el-table :data="tableData" stripe style="width: 100%" height="656">
                            <el-table-column prop="typeCode" label="类型编码"  ></el-table-column>
                            <el-table-column prop="typeName" label="类型名称"  ></el-table-column>
                            <el-table-column prop="description" label="描述"  ></el-table-column>
                            <el-table-column label="操作" fixed="right" width="100">
                                <template slot-scope="scope">
                                    <el-button @click="showEditDialog(scope.row)" type="text" size="small" v-if="permission.btn_masterData_updateProductionType">编辑</el-button>
                                    <el-button class="btn-del" @click="deleteProduct(scope.row)" type="text" size="small" v-if="permission.btn_masterData_deleteProductionType">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="物料组" name="2" v-if="permission.btn_masterData_listMaterialGroup">
                    <div>
                        <h3 style="margin-bottom:20px">物料组</h3>
                        <div class="table_common_operbar">
                            <el-row>
                                <el-button icon="el-icon-plus" type="primary" size="small" @click="addWindowShow()" v-if="permission.btn_masterData_addMaterialGroup">新增</el-button>
                                <el-upload class="import_upload" accept=".xls, .xlsx" :action="uploadUrl()"  :before-upload='beforeLoad' :on-success="uploadComplete" v-if="permission.btn_masterData_importMaterialGroup">
                                    <el-button icon="el-icon-upload el-icon--left" type='primary' size="small">导入</el-button>
                                </el-upload>
                                <div class="import_upload" v-if="permission.btn_masterData_downloadMaterialGroupTemplate">
                                    <a class="import_upload" :href="activeName==1?'/api/masterData/downloadProductionTypeTemplate':'/api/masterData/downloadMaterialGroupTemplate'">
                                        <el-button  size='small'>模板下载<i class="el-icon-download el-icon--right"></i></el-button>
                                    </a>
                                </div>
                            </el-row>
                        </div>

                        <el-table :data="tableData" stripe height="656">
                            <el-table-column prop="groupCode" label="物料组编码"  ></el-table-column>
                            <el-table-column prop="groupName" label="物料组名称"  ></el-table-column>
                            <el-table-column prop="description" label="描述"  ></el-table-column>
                            <el-table-column label="操作" fixed="right" width="100">
                                <template slot-scope="scope">
                                    <el-button @click="showEditDialog(scope.row)" type="text" size="small" v-if="permission.btn_masterData_updateMaterialGroup">编辑</el-button>
                                    <el-button class="btn-del"  @click="deleteProduct(scope.row)" type="text" size="small" v-if="permission.btn_masterData_deleteMaterialGroup">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="材质" name="3" v-if="permission.btn_kitting_kittingList">
                    <div>
                        <h3 style="margin-bottom:20px">材质</h3>
                        <div class="table_common_operbar">
                            <el-row>
                                <el-button icon="el-icon-plus" type="primary" size="small" @click="addWindowShow()" v-if="permission.btn_masterData_addMaterialGroup">新增</el-button>
                                
                            </el-row>
                        </div>

                        <el-table :data="tableData" stripe height="656">
                            <el-table-column prop="name" label="材质名称"  ></el-table-column>
                            <!-- <el-table-column prop="groupName" label="物料组名称"  ></el-table-column>
                            <el-table-column prop="description" label="描述"  ></el-table-column> -->
                            <el-table-column label="操作" fixed="right" width="100">
                                <template slot-scope="scope">
                                    <el-button @click="showEditDialog(scope.row)" type="text" size="small" v-if="permission.btn_masterData_updateMaterialGroup">编辑</el-button>
                                    <el-button class="btn-del"  @click="deleteProduct(scope.row)" type="text" size="small" v-if="permission.btn_masterData_deleteMaterialGroup">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="齐套" name="4" v-if="permission.btn_masterData_listMaterialGroup">
                    <div>
                        <h3 style="margin-bottom:20px">齐套</h3>
                        

                        <el-table :data="tableData" stripe height="750">
                            <el-table-column prop="warehouseName" label="仓库"  ></el-table-column>
                            <el-table-column prop="description" label="参与齐套判断"  >
                                <template slot-scope="scope">
                                    <el-checkbox :disabled="!permission.btn_kitting_updateKitting" @change="chekboxChange($event,scope.row)" v-model="scope.row.isKitting"></el-checkbox>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-card>

        <!-- 新增窗口开始 -->
        <el-dialog :title="`新增${title}`" :visible.sync="addDialogVisible" width="30%" center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="addForm" class="addForm">
                <el-row :gutter="20" v-if="this.activeName==3">
                    <el-col :span="16" :offset="4">
                        <div class="">
                            <span class="title" style="width:84px">材质名称：</span>
                            <el-form-item class="value" prop="name" :rules="rules.name">
                                <el-input ref="focusinput"  size="small" v-model="addForm.name" maxlength="80" placeholder="材质名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <div v-else>
                <!-- <el-row :gutter="20">
                    <el-col :span="16" :offset="4">
                        <div class="">
                            <span class="title" style="width:84px">{{title}}编码：</span>
                            <el-form-item class="value" prop="typeCode" :rules="rules.typeCode">
                                <el-input ref="focusinput" size="small" v-model="addForm.typeCode" maxlength="80" :placeholder="`${title}编码`"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row> -->
                <el-row :gutter="20">
                    <el-col :span="16" :offset="4">
                        <div class="">
                            <span class="title" style="width:84px">{{title}}编码：</span>
                            <el-form-item class="value" prop="typeCode" :rules="rules.typeCode">
                                <el-input ref="focusinput" size="small" v-model="addForm.typeCode" maxlength="80" :placeholder="`${title}编码`"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                 <el-row :gutter="20">
                    <el-col :span="16" :offset="4">
                        <div class="">
                            <span  class="title" style="width:84px">{{title}}名称：</span>
                            <el-form-item class="value" prop="typeName" :rules="rules.typeName">
                                <el-input  size="small"  v-model="addForm.typeName" maxlength="80" :placeholder="`${title}名称`" ></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="16" :offset="4">
                        <span>描述</span>
                        <el-input type="textarea" v-model="addForm.description" :rows="3" maxlength="255" :show-word-limit='true'></el-input>
                    </el-col>
                </el-row>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addProduct()">确 定</el-button>
                <el-button @click="addDialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>

        <!--编辑窗口开始-->
        <el-dialog :title="`编辑${title}`" :visible.sync="editDialogVisible" width="35%" center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="changeForm" class="addForm">
                <el-row :gutter="20" v-if="this.activeName==3">
                    <el-col :span="16" :offset="4">
                        <div class="">
                            <span class="title" style="width:84px">材质名称：</span>
                            <el-form-item class="value" prop="name" :rules="rules.name">
                                <el-input ref="focusinput"  size="small" v-model="addForm.name" maxlength="80" placeholder="材质名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <div v-else>
                    <el-row :gutter="20">
                        <el-col :span="16" :offset="4">
                            <div class="">
                                <span  class="title" style="width:84px">{{title}}名称：</span>
                                <el-form-item class="value" prop="typeName" :rules="rules.typeName">
                                    <el-input  size="small"  v-model="addForm.typeName" maxlength="80" :placeholder="`${title}名称`" ></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="16" :offset="4">
                            <span>描述</span>
                            <el-input type="textarea" v-model="addForm.description" :rows="3" maxlength="255" :show-word-limit='true'></el-input>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="updateProduct()">确 定</el-button>
                <el-button @click="editDialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <!--编辑窗口结束-->

       

        <!-- 批量导入提示框开始 --> 
        <el-dialog title="导入详情" style="z-index:99999999999" :close-on-click-modal="false" :visible.sync="exportDialogVisible" :width="(span?'25%':'30%')" center >
            <div class="exprot_info" style="text-align: center">
                <el-row :gutter="20">
                    <span>总共导入{{title}}条数：</span>
                    <span>{{exportInfo.total}}条</span>
                </el-row>
                <el-row :gutter="20">
                    <span>导入{{title}}成功条数：</span>
                    <span>{{exportInfo.success}}条</span>
                </el-row>
                <el-row :gutter="20">
                    <span>导入{{title}}失败条数：</span>
                    <span>{{exportInfo.fail}}条</span>
                </el-row>
            </div>
            <span slot="footer" class="el-dialog__footer" style="text-align: center;" center>
                <a class="import_upload" v-if="exportInfo.url" :href="exportInfo.url">
                    <el-button type="primary" >下载失败数据</el-button>
                </a>
                <el-button type="primary" style="margin-left:10px" @click="()=>{this.exportDialogVisible = false}">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 批量导入提示框结束 -->
    </div>
</template>

<script>

export default {
    name: 'MasterDataConfig',
	data () {
        return {
            activeName:'1',
            cloneData:{},
            exportInfo:{
                success:0,
                fail:0,
                url:null,
                total:0
            },
            title:'类型',
            exportDialogVisible:false,
            W:false,
            addForm:{
                typeName:'',
                typeCode:'',
                description:''
            },
            rules:{
                name:[{ required: true, message: '请输入材质名称', trigger: 'blur' }],
                typeName:[
                    { required: true, message: '请输入名称', trigger: 'blur' }
                ],
                typeCode:[
                    { required: true, message: '请输入编码', trigger: 'blur' }
                ],
            },
            addDialogVisible: false,
            editDialogVisible:false,
            tableData:[],
            permission:JSON.parse(localStorage.getItem("permission")) 
        }
    },
    mounted:function(){
        this.initTable();
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
         w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    methods:{
        uploadUrl(){
            if(this.activeName==1){
                return `/api/masterData/importProductionType?token=${localStorage.getItem("token")}`
            }else{
                return `/api/masterData/importMaterialGroup?token=${localStorage.getItem("token")}`
            }
        },
        
        handleClick(){
            if(Number(this.activeName) ==1){
                this.title = '类型'
            }else if(Number(this.activeName) ==2){
                this.title = '物料组'
            }else{
                this.title = '材质'
            }
            this.search()
        },

        search:function(){
            let url = ''
            if(Number(this.activeName==1)){
                url = '/api/masterData/listProductionType'
            }else if(Number(this.activeName==2)){
                url = '/api/masterData/listMaterialGroup'
            }else if(Number(this.activeName==3)){
                url = '/api/masterData/material-quality/list'
            }else{
                url = '/api/kitting/kittingList'
                
            }
            this.$RequestUtil.get({
                url,
                type:'sync',
				params: {},
                success: (res) => {
                    if(res.msg == this.$Global.RESPONSE.SUCCESS){
                        this.tableData = res.data;
                        
                    }else{
                        this.$message.error(res.message||res.msg)
                    }
                    
                }
            });
        },

        async chekboxChange(ev,row){
            let {data,code,message,msg} = await this.$RequestUtil.postAsync({url: "/api/kitting/updateKitting",params: {...row}})
            if(code==0){
                this.$message.success('更新成功!')
            }else{
              this.$message.error(msg||message)
            }
        },
      
        initTable:function(){
            this.search();
        },

        addWindowShow:function(){
            this.addDialogVisible = true;
            this.addForm = {
                id:null,
                itemName:'',
                itemModel:'',
                itemCode:'',
                remark:''
            }
            setTimeout(()=>{
                this.$refs.focusinput.focus()
                this.$refs['addForm'].clearValidate()
            
            },0)
        },
  
        addProduct:function(){
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    let url = ''
                    if(Number(this.activeName==1)){
                        url = '/api/masterData/addProductionType'
                    }else if(Number(this.activeName==2)){
                        url = '/api/masterData/addMaterialGroup'
                        this.addForm.groupName = this.addForm.typeName
                        this.addForm.groupCode = this.addForm.typeCode
                    }else{
                        url = '/api/masterData/material-quality/create'
                    }
                    this.$RequestUtil.post({
                        url,
                        type:'sync',
                        params: this.addForm,
                        success: (res) => {
                            if(res.code == 0){
                                this.$message({
                                    type:'success',
                                    message:'添加成功'
                                })
                                this.$store.commit("add_reloadPages",['/Material/Material']);
                                this.initTable();
                                this.addDialogVisible = false;
                            }else{
                                this.$message({
                                    type: 'error',
                                    message: res.message||res.msg
                                });
                            }
                        }
                    });
                }else{
                    this.$message({
                        type: 'error',
                        message: '请补充必填项!'
                    });
                }
            });
        },

        updateProduct:function(){
            this.$refs['changeForm'].validate((valid) => {
                if (valid) {
                    let url = ''
                    if(Number(this.activeName==1)){
                        url = '/api/masterData/updateProductionType'
                    }else if(Number(this.activeName==2)){
                        url = '/api/masterData/updateMaterialGroup'
                        this.addForm.groupName = this.addForm.typeName
                        this.addForm.groupCode = this.addForm.typeCode
                    }else{
                        url = '/api/masterData/material-quality/update'
                    }
                    this.$RequestUtil.post({
                        url,
                        type:'sync',
                        params: this.addForm,
                        success: (res) => {
                            if(res.code == 0){
                                this.$message({
                                    type:'success',
                                    message:'修改成功'
                                })
                                this.$store.commit("add_reloadPages",['/Material/Material']);
                                this.initTable();
                                this.editDialogVisible = false;
                            }else{
                                this.$message({
                                    type:'error',
                                    message:res.msg||res.message
                                })
                            }
                        }
                    });
                }else{
                    this.$message({
                        type: 'error',
                        message: '请补充必填项!'
                    });
                }
            });

        },
        
        showEditDialog:function(rowData){
            this.addForm = commonUtils.cloneObj(rowData)
            if(this.activeName==2){
                this.$set(this.addForm,'typeName',this.addForm.groupName)
                this.$set(this.addForm,'typeCode',this.addForm.groupCode)
            }
            this.editDialogVisible = true
            this.$nextTick(()=>{
                this.$refs['changeForm'].clearValidate()
            })
        },

        deleteProduct:function(rowData) {
            this.$confirm(`此操作将删除该${this.title}, 是否继续?`, '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let url = ''
                let methed = 'post'
                if(Number(this.activeName==1)){
                    url = '/api/masterData/deleteProductionType'
                }else if(Number(this.activeName==2)){
                    url = '/api/masterData/deleteMaterialGroup'
                }else{
                    url = '/api/masterData/material-quality/delete'
                    methed = 'get'
                }
                this.$RequestUtil[`${methed}`]({
                    url,
                    type:'sync',
                    params: {
                        id:rowData.id
                    },
                    success: (res) => {
                        if(res.code != -1){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.initTable();
                            this.$store.commit("add_reloadPages",['/Material/Material']);
                        }else {
                          this.$message({
                            type: 'error',
                            message: res.message
                          });
                        }
                    }
                });
            });
        },
      
        beforeLoad(file){
            let fileSize = file.size/1024/1024
            fileSize = Math.round(fileSize*100)/100
            if(fileSize>=10){
                this.$message({
                    type:'error',
                    message:`文件大小不能超过5M,当前上传${file.name}大小为${fileSize}M`
                })
                return false
            }
            this.$RequestUtil.loading()
        },

        uploadComplete:function(response, file, fileList) {
            this.$RequestUtil.loading().close()
            if(response != null){
                if(response.code == 0){
                    this.exportInfo.url = response.data.url
                    this.exportInfo.success = response.data.success
                    this.exportInfo.fail = response.data.fail
                    this.exportInfo.total = Number(response.data.fail)+Number(response.data.success)
                    this.exportDialogVisible = true
                    this.initTable();
                    this.$store.commit("add_reloadPages",['/Material/Material']);
                }else if(response.code == -1){
                    this.$message({
                        type: 'error',
                        message: response.msg
                    });
                }else if(response.code == 10){
                        this.$message({
                        type:'error',
                        message:'登入过期！'
                    })
                    this.$router.push({path: '/Login',name: 'Login'})
                    return
                    }
            }
        },

    }
}
</script>
<style>
  .import_upload>.el-upload-list{
      display: none;
   }
   #master-data-config .part-table .el-form-item{
       margin-bottom: 0px !important;
   }
   .table_searchbar .el-button--mini, .el-button--mini.is-round {
        padding: 7px 10px;
    }
</style>
<style scoped>
    .copy{
        background-color: transparent;
        background: rgb(64,158,255);
        border-color: #66b1ff;
        color: #FFF;
        padding: 9px 15px;
        font-size: 12px;
        border-radius: 3px;
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        border: 1px solid #DCDFE6;
        margin: 0;
        font-weight: 500;
        outline: none
    }
    .copy:hover{
        outline: none
        
    }
    .table_searchbar .title11{
        color:  #606266;
        font-family: NotoSansHans-Regula;
        font-size: 14px;
    }
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }

    .table_searchbar{
        width:100%;
        margin-top: 10px;
        margin-bottom: 20px;
    }
    .import_upload{
        display: inline;
    }
    .page{
        display: flex;
        justify-content: flex-end;
    }
    .total_page{
        margin-top: 20px;
        margin-right: 26px;
        color:#606266;
        font-size: 14px;
    }
    .key{
        font-size: 16px;
        color:#c0c4cc;
        font-family: NotoSansHans-Regula;
        padding-right:10px;
    }
    .value{
        font-size:16px;
        color:#999;
        font-family: NotoSansHans-Regula;
    }
    .addForm .value{
        display: inline-block;
        max-width: 180px;
    }
    .addForm .title{
        width: 70px;
        text-align: right;
        display:inline-block
    }
    @media screen and (max-width: 1380px){
    
        
        .page{
            display: flex;
            justify-content: flex-end;
            margin-bottom:30px;
        }
    }
    /* @media screen and (max-width: 1500px) and (min-width:1381px){
        .view_dialog{
            width: 70% !important;
        }
    }
    @media screen  and (min-width:1551px){
        .view_dialog{
            width: 55%
        }
    } */
    .color-blue{
        color:blue;
    }
    .el-icon-circle-close-outline:hover{
        color:red;
    }
    
</style>



// WEBPACK FOOTER //
// src/views/masterdata/MasterDataConfig.vue